/**
 * 테마 모드
 */
export enum ThemeMode {
  /** 라이트 모드 */
  LIGHT = 'light',
  /** 다크 모드 */
  DARK = 'dark',
}
